import React from 'react'

import FormError from "../../../../../../../core/gd-form/common/form-error/form-error"
import FormManager from "../../../../../../../core/gd-form/common/form-manager"
import {ProjectAccess} from "../../../../../../../core/gd/const/project"

// @ts-ignore
import SelectUser from "../../../../../../../core/gd-ui/select-user/select-user"

type Props = {
    form: FormManager
}

// const debug = "FormOwnerSelector"
const debug = false

export default function FormOwnerSelector(props: Props) {
    let users
    const parentProjectId = props.form.getValue('parentProject')

    debug && console.log(debug, 'render', parentProjectId)

    if (parentProjectId) {
        users = gd.session.projects.get(parentProjectId)?.userIds(ProjectAccess.LIMITED)
    } else {
        users = gd.session.companyUsers.filterByCompanyAndRoles(gd.companyId).map((companyUser:any)=>companyUser.user.id)
    }

    return (
        <div className="row">
            <div className="label">Project owner</div>
            <div className="element">
                <SelectUser className       = "owner-user-selector"
                            form            = {props.form}
                            name            = "owner"

                            options         = {users}
                            renderValue     = "icon-name"
                            underlined      = "always"

                            placeholder     = "Not assigned"
                            canHaveNoValue  = {true}
                            noValueValue    = {null}
                            noValueLabel    = "Not assigned"/>


                <FormError form={props.form} name="owner"/>
            </div>
        </div>
    )
}